"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1576 = void 0;
exports.f1576 = {
    "بدوي": [
        537
    ],
    "بلۆچی": [
        618
    ],
    "بلتی": [
        766
    ],
    "بختیاری": [
        1058
    ],
    "بهاس مليسيا": [
        5068
    ],
    "بهاس": [
        5068
    ],
    "بَهَسَ سُوگ": [
        7735
    ],
    "بَهَسَ": [
        7735
    ]
};
